import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

const TermsPage = () => {
  return (
    <>
      <Header />
      <div className="container mx-auto p-4 text-black text-lg" style={{ backgroundColor: '#E9A969' }}>
        <h1 className="text-2xl font-bold">Terms of Service</h1>
        <p><strong>Effective Date:</strong> 20 July 2025</p>

        <p>Welcome to <strong>Cosmelytix</strong>! These Terms of Service ("Terms") govern your access to and use of our web application, including all related features, services, and content (collectively, the "Service" or "Cosmelytix").</p>

        <p>By accessing or using Cosmelytix, you agree to be bound by these Terms and our <a href="#" className="text-[#5F40A1]">Privacy Policy</a>. If you do not agree, do not use our Service.</p>

        <h2>1. Eligibility</h2>
        <p>You must be at least 13 years old (or the age of digital consent in your country) to use Cosmelytix. By using the Service, you affirm that you meet the eligibility requirements.</p>

        <h2>2. Account Registration and Access</h2>
        <p>To use Cosmelytix, you must log in using a third-party account such as:</p>
        <ul>
          <li><strong>Facebook</strong></li>
          <li><strong>Google (Gmail)</strong></li>
        </ul>
        <p>By logging in through one of these services, you authorize us to access certain information as permitted by your account settings and applicable privacy policies.</p>
        <p><strong>You are responsible for all activity that occurs under your account.</strong></p>

        <h2>3. Use of Services</h2>
        <p>Once logged in, users can:</p>
        <ul>
          <li>View and access services listed on Cosmelytix.</li>
          <li>Interact with features made available from time to time.</li>
        </ul>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service for any unlawful or harmful purpose.</li>
          <li>Reverse-engineer, scrape, or interfere with the functionality of Cosmelytix.</li>
          <li>Attempt to gain unauthorized access to our systems.</li>
        </ul>
        <p>We reserve the right to suspend or terminate your account at any time, with or without notice, for conduct that we believe violates these Terms or is otherwise harmful.</p>

        <h2>4. User Data and Privacy</h2>
        <p>By using Cosmelytix, you agree to the collection and use of your data in accordance with our <a href="#" className="text-[#5F40A1]">Privacy Policy</a>. We do not store your login credentials from third-party providers.</p>
        <p>We may collect data about your use of the Service to improve features and personalize your experience.</p>

        <h2>5. Intellectual Property</h2>
        <p>All content, branding, and technology used in Cosmelytix is owned or licensed by us and protected by copyright and other laws. You may not use our trademarks or materials without written permission.</p>

        <h2>6. Third-Party Services</h2>
        <p>Cosmelytix may display links or access to third-party services. We are not responsible for the content or practices of these third parties.</p>

        <h2>7. Modifications</h2>
        <p>We may update these Terms from time to time. We will notify you by email, posting a notice in the app, or updating the "Effective Date" above. Continued use of Cosmelytix after any changes constitutes your acceptance of the new Terms.</p>
        
        <h2>8. Termination</h2>
        <p>We may suspend or terminate your access to Cosmelytix at any time, with or without cause or notice.</p>
        <p>You may stop using the Service at any time by logging out or discontinuing access.</p>

        <h2>9. Disclaimers</h2>
        <p>Cosmelytix is provided <strong>"as is"</strong> without warranties of any kind. We do not guarantee the accuracy, completeness, or availability of services or content. Your use of the Service is at your own risk.</p>

        <h2>10. Limitation of Liability</h2>
        <p>To the maximum extent permitted by law, Cosmelytix and its team shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service.</p>

        <h2>11. Governing Law</h2>
        <p>These Terms shall be governed by the laws of [Your Country/State], without regard to its conflict of law principles.</p>

        <h2>12. Contact</h2>
        <p>If you have questions about these Terms, you may contact us at:<br />
        <a href="mailto:[info@cosmelytix.com]" style={{'color': '#5F40A1'}}>info@cosmelytix.com</a><br />
            <a href="https://cosmelytix.com/" className="text-[#5F40A1]">cosmelytix.com</a>
        </p>
      </div>
      <Footer />
    </>
  );
};

export default TermsPage;